/**
 * @generated SignedSource<<541fdebc5a9964d94622523aa2b06cf9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productSidePanelContent_RemoveMoqMutation$variables = {
  moqRuleId: string;
  productIds: ReadonlyArray<number>;
};
export type productSidePanelContent_RemoveMoqMutation$data = {
  readonly removeProductsFromMoqRule: {
    readonly result: boolean;
  };
};
export type productSidePanelContent_RemoveMoqMutation = {
  response: productSidePanelContent_RemoveMoqMutation$data;
  variables: productSidePanelContent_RemoveMoqMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "moqRuleId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productIds"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "moqRuleId",
        "variableName": "moqRuleId"
      },
      {
        "kind": "Variable",
        "name": "productIds",
        "variableName": "productIds"
      }
    ],
    "concreteType": "ProductAssignmentResult",
    "kind": "LinkedField",
    "name": "removeProductsFromMoqRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_RemoveMoqMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "productSidePanelContent_RemoveMoqMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "7d0488e4ba0628324b78f9fbbdcefa94",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_RemoveMoqMutation",
    "operationKind": "mutation",
    "text": "mutation productSidePanelContent_RemoveMoqMutation(\n  $moqRuleId: ID!\n  $productIds: [Long!]!\n) {\n  removeProductsFromMoqRule(moqRuleId: $moqRuleId, productIds: $productIds) {\n    result\n  }\n}\n"
  }
};
})();

(node as any).hash = "f5cba911bfc14897eadd1c85ef4b488b";

export default node;
